<app-company-reservation-flow-v2
  #reservationFlow
  [editingReservationId]="editingReservationId"
  [editingReservationCode]="editingReservationCode"
  [isApprovingTwoPhase]="true"
>
</app-company-reservation-flow-v2>
